import { ensureError } from '@passionware/platform-js';
import type { Resource } from '__types__';
import { useState } from 'react';
import {
  ResourceCombobox,
  type ResourceComboboxProps
} from 'v5/patterns/resource/ResourceCombobox';
import { myServices } from 'v5/services/services.connected.app';

/**
 * For v1 screens, which have no `services` and want the whole resource of a
 * pick, not just its id. The picker stays disabled while the resource loads.
 */
export function ResourceComboboxConnected({
  onSelect,
  onClear,
  disabled,
  ...props
}: Omit<ResourceComboboxProps, 'services' | 'onChange'> & {
  onSelect(resource: Resource): void;
  onClear?(): void;
}) {
  const [loading, setLoading] = useState(false);
  return (
    <ResourceCombobox
      {...props}
      disabled={disabled || loading}
      services={myServices}
      onChange={id => {
        if (id === null) {
          onClear?.();
          return;
        }
        setLoading(true);
        myServices.resourceService.ensureItem(id).then(
          resource => {
            setLoading(false);
            onSelect(resource);
          },
          (cause: unknown) => {
            setLoading(false);
            myServices.toastService.open({
              type: 'error',
              message: ensureError(cause).message
            });
          }
        );
      }}
    />
  );
}
